import React, { FunctionComponent, useState } from "react";
import { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import Loading from "../../Components/Loading/Loading";
// import { fetchFAQ } from "../../Services/resources";
import { fetchFAQ, deleteFAQ } from "../../Services/faq";
// import { deleteFAQ } from "../../Services/resources";
import styles from "./FAQPanel.module.css";
import Lottie from "react-lottie";
import noData from "../../Assets/animations/no-data.json";
import { themeColors } from "../../Components/theme";
import topBarStyles from "../../Components/TopBar/TopBar.module.css";
import { showSnackbarAction ,setCurrentRoute} from "../../Redux/actions";
import { googleAnalytics, googleAnalyticsCTAClick } from "../../Services/users";
import { useHistory, useLocation } from "react-router-dom";


type props = { history: any; user: any, theme: any;authToken?: any,userPreference?:any };
const FAQPanel: FunctionComponent<props> = ({ history, user, theme,authToken,userPreference }) => {
  const [faqList, setfaqList] = useState<any[] | undefined>(undefined);
  const dispatcher = useDispatch();
   const [cRoute,setCRoute]=useState("") 
               const location: any = useLocation();                    
                                  useEffect(() => {
                                    dispatcher(setCurrentRoute(location.pathname))
                                    setCRoute(location.pathname)
                                  }, [location]);
  let panel = ""
  useEffect(() => {
    if (user.organization_id) {
      fetchFAQ(user.organization_id, (data) => setfaqList(data));
    }
  }, [user]);
  useEffect(()=>{
  },[authToken])
  const handleDelete = (faq: any) => {
    deleteFAQ(
      faq._id,
      dispatcher,
      history,
      authToken
    );
  }
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: noData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const [isGACalled, setIsGACalled] = useState<any>(false);
  useEffect(()=>{
    if(isGACalled === false){
      if(user?.uid && user?.profile){
        setIsGACalled(true)
        googleAnalytics('FAQ_Screen',user)
      }
    }
  },[user])
  return (
    <div
      // className={styles.parent}
      className="container-fluid p-4 d-flex flex-column gap-4"
      style={{ minHeight: "100vh", height: "fit-content", ...containerStyles }}>
      {faqList === undefined && <Loading />}
      <div
        // className={styles.topBar}
        className="d-flex justify-content-between"
      >
        <h5
        // className={styles.title}
        >FAQ Section</h5>
        <button
          className={styles.addButton}
          onClick={() => 
            {
              googleAnalyticsCTAClick("Add FAQ Button","FAQ Screen",user)  
            userPreference.faq_create_approved === false ?
            dispatcher(showSnackbarAction('You are not allowed to add FAQ . Please contact your admin', 'error')) :
            history.push("/addFAQ")}}
        >
          Add FAQ
        </button>
      </div>
      <div
        // className={styles.child}
        className="d-flex flex-column gap-4"
        style={containerStyles}>
        {faqList && faqList.length > 0 ? (
          faqList?.map((item, index) => (
            <div
              // className={styles.FAQContainer}
              className="card p-4 shadow rounded"
              style={cardContainerStyles}
              key={index}>
              <h6
                className={styles.heading}
              >{item.question}</h6>
              {/* <div className={styles.container}>

                        {item.question}</div> */}
              {/* <h6>{item.question}</h6> */}
              <div className={styles.line}></div>
              <p>{item.answer}</p>
              {/* <p className={styles.heading}>{`Answer ${index + 1}`}</p> */}
              {/* <div className={styles.container}>{item.answer}</div> */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end"
                }}>
                <div style={{ padding: "5px" }}><button
                  style={{
                    cursor: "pointer",
                    backgroundColor: "#e34234",
                    border: "red",
                    color: "white",
                    width: "80px",
                    height: "30px",
                    borderRadius: "0.25rem",
                    // fontFamily: "sans-serif",
                    boxSizing: "border-box"
                  }} type="button"
                  onClick={() => {
                    googleAnalyticsCTAClick("Delete FAQ Button","FAQ Screen",user) 
                    userPreference.faq_delete_approved === false ?
                    dispatcher(showSnackbarAction('You are not allowed to delete FAQ . Please contact your admin', 'error')) :
                    handleDelete(item)
                  }}>
                  Delete</button></div>
                <div style={{ padding: "5px" }}><button
                  style={{
                    cursor: "pointer",
                    backgroundColor: "#279ea0",
                    border: "red",
                    color: "white",
                    width: "80px",
                    height: "30px",
                    borderRadius: "0.25rem",
                    // fontFamily: "sans-serif",
                    boxSizing: "border-box"
                  }} type="button"
                  onClick={() =>{
                    googleAnalyticsCTAClick("Edit FAQ Button","FAQ Screen",user) 
                    userPreference.faq_update_approved === false ?
                    dispatcher(showSnackbarAction('You are not allowed to edit FAQ . Please contact your admin', 'error')) : 
                    history.push({
                      pathname: '/editFAQ',
                      state: { "item": item }
                    })
                  }}
                >Edit</button></div>
              </div>
            </div>
          ))
        ) : (
          <div>
            <Lottie options={defaultOptions} height={300} width={300} />
            <h5 className="text-center">No FAQ Available</h5>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode,
    authToken: state.user.authToken,
    userPreference:state.userPreference.data
  };
};

export default connect(mapStateToProps)(FAQPanel);